export const visuals00 = [
  {
    id: 1,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img10.jpg",
  },
  {
    id: 2,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img19.jpg",
  },
  {
    id: 3,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img13.jpg",
  },
  {
    id: 4,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img07.jpg",
  },
  {
    id: 5,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img01.jpg",
  },
];

export const visuals01 = [
  {
    id: 1,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img10.jpg",
  },
  {
    id: 2,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img15.jpg",
  },
  {
    id: 3,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img18.jpg",
  },
  {
    id: 4,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img11.jpg",
  },
  {
    id: 5,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img17.jpg",
  },
  {
    id: 6,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img19.jpg",
  },
  {
    id: 7,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img16.jpg",
  },
  {
    id: 8,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img14.jpg",
  },
  {
    id: 9,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img12.jpg",
  },
  {
    id: 10,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img13.jpg",
  },
];

export const visuals02 = [
  {
    id: 1,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img07.jpg",
  },
  {
    id: 2,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img06.jpg",
  },
  {
    id: 3,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img01.jpg",
  },
  {
    id: 4,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img02.jpg",
  },
  {
    id: 5,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img05.jpg",
  },
  {
    id: 6,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img03.jpg",
  },
  {
    id: 7,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img04.jpg",
  },
  {
    id: 8,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img08.jpg",
  },
  {
    id: 9,
    img: "https://hamzahfayad.github.io/photos-collection/assets/img09.jpg",
  },
];
